import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useSpring, animated } from "react-spring";

const SlideToggleContent = ({ id, className, isVisible, children }) => {
	const panelRef = useRef(null);

	const { height, opacity } = useSpring({
		from: {
			height: 0,
			opacity: 0,
		},
		to: async next => {
			await next({
				height: isVisible ? panelRef.current.scrollHeight : 0,
				opacity: isVisible ? 1 : 0,
			});
			await next({
				height: isVisible ? "auto" : 0,
				opacity: isVisible ? 1 : 0,
			});
		},
		config: {
			duration: 300,
		},
	});

	return (
		<animated.div
			ref={panelRef}
			style={{
				height,
				opacity,
				overflow: "hidden",
			}}>
			<div accordion-section="panel">
				<div id={id} role="region" aria-labelledby={`accordion${id}`} className={className}>
					{children}
				</div>
			</div>
		</animated.div>
	);
};

SlideToggleContent.propTypes = {
	id: PropTypes.string.isRequired,
	className: PropTypes.string,
	isVisible: PropTypes.bool.isRequired,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

SlideToggleContent.defaultProps = {
	className: undefined,
};

export default SlideToggleContent;
export { SlideToggleContent };
